<template>
  <div v-if="isContentReady" id="app" class="layout">
    <NavBar :is-collapsed="isNavCollapsed" class="layout__nav" />

    <ScrollBox
      tag="main"
      class="layout__scrollbox"
      emit-scroll-event
      scroll-on-hash-change
      @scroll="onScroll"
      @mounted="onScrollBoxMount"
    >
      <Transition name="page" mode="out-in" appear @after-leave="onPageLeave">
        <RouterView v-if="!isContentLoading" :key="$route.name" class="layout__view" />
      </Transition>

      <SiteFooter v-show="!isContentLoading" />
    </ScrollBox>

    <ContactForm />
    <MobileMenu />
  </div>
</template>

<script>
import { NavBar, SiteFooter, ContactForm, MobileMenu } from '@/components/layout'

export default {
  name: 'App',
  components: { NavBar, SiteFooter, ContactForm, MobileMenu },
  data() {
    return {
      isContentReady: false,
      isContentLoading: true,
      scrollingElement: null,
      navShouldCollapse: false
    }
  },
  computed: {
    isOverlayOpen() {
      return !!this.$route.query.overlay
    },
    isNavCollapsed() {
      return !this.isOverlayOpen && this.navShouldCollapse
    }
  },
  watch: {
    '$lang.current': {
      immediate: true,
      handler(lang, prevLang) {
        if (lang === prevLang) return
        this.fetchContent(lang)
      }
    }
  },
  methods: {
    fetchContent(lang) {
      this.isContentLoading = true

      this.$store.dispatch('fetchContent', lang).then(() => {
        this.isContentLoading = false
        this.isContentReady = true
      })
    },
    onScroll({ scrollTop }) {
      const shouldCollapse = scrollTop >= 45
      if (shouldCollapse !== this.navShouldCollapse) this.navShouldCollapse = shouldCollapse
    },
    onScrollBoxMount(scrollingElement) {
      this.scrollingElement = scrollingElement
    },
    onPageLeave() {
      const shouldScrollToTop = true
      if (this.scrollingElement && shouldScrollToTop) this.scrollingElement.scrollTop = 0
    }
  }
}
</script>
